import { GitCommit, MessageSquare, RefreshCw, X } from "lucide-react";
import React from "react";

const stateLabel = (state) => {
	if (state === "merged") return "Merged";
	if (state === "closed") return "Closed";
	if (state === "opened") return "Reopened";
	return "State changed";
};

const describe = (change) => {
	if (change.type === "comments") {
		return {
			Icon: MessageSquare,
			text: `${change.count} new comment${change.count > 1 ? "s" : ""}`,
		};
	}
	if (change.type === "state") {
		return { Icon: GitCommit, text: stateLabel(change.to) };
	}
	return { Icon: RefreshCw, text: "Updated" };
};

export const ActivityBadge = ({ activity, onDismiss }) => {
	if (!activity?.length) return null;

	return (
		<span className="inline-flex items-center gap-1 rounded-full bg-[var(--color-accent-muted)] px-2 py-0.5 text-xs font-medium text-[var(--color-accent)]">
			{activity.map((change, index) => {
				const { Icon, text } = describe(change);
				return (
					<span key={change.type} className="inline-flex items-center gap-1">
						{index > 0 && <span className="opacity-50">·</span>}
						<Icon className="w-3 h-3" />
						{text}
					</span>
				);
			})}
			{onDismiss && (
				<button
					type="button"
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						onDismiss();
					}}
					aria-label="Mark as seen"
					title="Mark as seen"
					className="ml-0.5 rounded-full p-0.5 hover:bg-[var(--color-accent-muted)] focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-ring)]"
				>
					<X className="w-3 h-3" />
				</button>
			)}
		</span>
	);
};

export default ActivityBadge;
